/* eslint-disable @typescript-eslint/ban-types */
import { useForm, FieldValues, UseFormProps, UseFormSetValue } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AnyObjectSchema } from 'yup';

interface FormOptions<
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object,
> extends UseFormProps<TFieldValues, TContext> {
  schema: AnyObjectSchema | undefined;
}

export default function <
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object,
>(options: FormOptions<TFieldValues, TContext>) {
  const { setValue, ...otherProps } = useForm<TFieldValues, TContext>({
    mode: 'all',
    ...options,
    resolver: options.schema ? yupResolver(options.schema) : undefined,
  });

  const setValueCustom: UseFormSetValue<TFieldValues> = (name, value, options) =>
    setValue(name, value, { shouldDirty: true, shouldValidate: true, ...options });

  return {
    setValue: setValueCustom,
    ...otherProps,
  };
}
